import fs from "fs";
import path from "path";

import {
  Container,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import matter from "gray-matter";
import { MDXRemote } from "next-mdx-remote";
import { serialize } from "next-mdx-remote/serialize";
import Head from "next/head";

import { getLayout as getSiteLayout } from "@cosy/layouts/Site";

function SupportEmail() {
  return <Link href="mailto:support@cosy.app">support@cosy.app</Link>;
}

function SupportPhone() {
  return "1 415-226-6796";
}

const components = {
  a: Link,
  SupportEmail,
  SupportPhone,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
};

export default function PrivacyPolicyPage({ source, data }) {
  return (
    <Container maxWidth="md">
      <Head>
        <title>{data.title} · Cosy</title>
      </Head>
      <Typography component="div">
        <MDXRemote {...source} components={components} />
      </Typography>
    </Container>
  );
}

PrivacyPolicyPage.authRequired = false;

export async function getStaticProps({ params }) {
  const { doc } = params;
  const fileContents = fs.readFileSync(
    path.join(process.cwd(), "content", "legal", `${doc}.mdx`),
    "utf8"
  );
  const { content, data } = matter(fileContents);
  const mdxSource = await serialize(content);
  return { props: { source: mdxSource, data } };
}

export async function getStaticPaths() {
  return {
    paths: [
      { params: { doc: "privacy-policy" } },
      { params: { doc: "terms-of-use" } },
    ],
    fallback: false,
  };
}

PrivacyPolicyPage.getLayout = getSiteLayout;
